<template>
  <div>
    <el-container class="container">
      <img src="@/assets/imgs/background.png" class="background" />
      <el-header>
        <BaseHeader></BaseHeader>
      </el-header>
      <div
        style="overflow: auto; height: calc(100vh - 60px)"
        ref="scrollContainerRef"
      >
        <el-main
          :style="{ padding: '0px', 'min-height': '100%' }"
          class="base-main"
        >
          <router-view
            style="flex: 1"
            @save-scroll="saveScrollPosition"
            @set-scroll="setScrollPosition"
          ></router-view>
        </el-main>
        <el-footer style="padding: 0">
          <BaseFooter></BaseFooter>
        </el-footer>
      </div>
    </el-container>
    <DialogLogin ref="dialogLoginRef"></DialogLogin>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  defineProps,
  defineEmits,
  computed,
  provide,
  onMounted,
  nextTick,
  onUnmounted,
} from "vue";
import { httpPost } from "@/api/httpService.js";
import BaseHeader from "./BaseHeader.vue";
import BaseFooter from "./BaseFooter.vue";
import { useRoute, useRouter } from "vue-router";
import DialogLogin from "../base/DialogLogin.vue";

//打开登录弹框
const dialogLoginRef = ref(null);
provide("openDialogLogin", () => {
  dialogLoginRef.value.openDialog();
});
const route = useRoute();
const ifHidePadding = computed(() => {
  return route.meta.ifHidePadding;
});

//保存滚动位置
const scrollContainerRef = ref(null);
const saveScrollPosition = () => {
  if (scrollContainerRef.value) {
    sessionStorage.setItem(
      "cgsg_homeScrollTop",
      scrollContainerRef.value.scrollTop
    );
  }
};
const setScrollPosition = (savedPosition) => {
  if (scrollContainerRef.value) {
    nextTick(() => {
      scrollContainerRef.value.scrollTop = savedPosition;
    });
  }
};

onMounted(() => {
  sessionStorage.setItem("cgsg_homeScrollTop", 0);
  setScrollPosition(0);
});
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  overflow: hidden;
  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    // filter: blur(4px);
    z-index: -1;
    object-fit: cover;
  }
}
</style>
